import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button } from "react-bootstrap";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import Benefit from "src/icons/Benefit";
import Calendar from "src/icons/Calendar";
import Free from "src/icons/Free";
import Scheme from "src/icons/Scheme";
import Valid from "src/icons/Valid";
import VideoCamera from "src/icons/Video-camera";
import Watch from "src/icons/Watch";
import { sButton } from "src/styles/sButton.module.scss";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sWhyToUseCard } from "src/styles/sWhyToUseCard.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
};

function WhyToUseInstructors({ style, className }: Props) {
  const { locale: lang, push } = useRouter();

  return (
    <>
      <div
        className={composeClassNames([
          sWhyToUseCard,
          className,
          "whyToUse-cards",
        ])}
      >
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Free />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Profile for free`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Present yourself and your offer completely free of charge.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Benefit />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Benefit program`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Take advantage of interesting discounts and bonuses from our partners.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Watch />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Courses, streams and audio`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Offer your on-line content and build passive income.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Calendar />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Events and festivals`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Offer your weekend stays, retreats or festivals.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Valid />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Publishing and selling`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Don't burden yourself with administration, focus on what you like.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <Scheme />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`More sales channels`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Sell through Anandita, on your website or in the network of partners.`}
              />
            </p>
          </div>
        </div>
        <div className="whyToUse-card">
          <div className="whyToUse-card-image">
            <VideoCamera />
          </div>
          <div className="whyToUse-card-text">
            <Heading
              type={`h4`}
              title={<Translate tKey={`Borrow equipment`} />}
              className={composeClassNames([
                sGroupTitle,
                "whyToUse-card-title",
              ])}
            />
            <p>
              <Translate
                tKey={`Have you taken care of the content but don't have the equipment? Borrow it.`}
              />
            </p>
          </div>
        </div>
      </div>
      <div className={"show-all"}>
        <Button
          variant={`primary`}
          onClick={() => push("/join-us")}
          className={composeClassNames([sButton])}
        >
          <Translate tKey={`Join Anandita and create profile`} />
        </Button>
      </div>
    </>
  );
}

export default WhyToUseInstructors;
